
import { CountUp } from 'countup.js';

const countUp = {
    counters: [],
    options: {
        separator: '.',
    },
    init: function() {
        const self = this;
        self.counters = document.querySelectorAll('.js-counter');

        if (self.counters.length) {
            // Create Intersection Observer
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        self.start(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.1, // Trigger when at least 10% of the element is visible
                rootMargin: '50px' // Add 50px margin to trigger slightly before element enters viewport
            });

            // Observe each counter
            self.counters.forEach(counter => {
                observer.observe(counter);
            });
        }
    },
    start: function(counter) {
        const self = this;
        const value = parseInt(counter.dataset.counterValue);

        let instance = new CountUp(counter, value, self.options);
        if (!instance.error) {
            instance.start();
        } else {
            console.error(instance.error);
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    countUp.init();
});
